import type { MarketIdentifiers } from '$lib/types/market';
import { Interface } from 'ethers/lib/utils.js';
import abi from '$lib/web3/abi';
import { MARKET_ADDRESES } from '$lib/web3/addresses';
import { SYNTHETIX_PERP_CONNECTOR, SYNTHETIX_PERP_LIMIT_CONNECTOR } from './constants';
import { getSynthetixConnector } from './version';
import type { IConnectorReturnData } from '../types';

export async function trade(
	marketIdentifier: MarketIdentifiers,
	sizeDelta: string,
	priceImpact: string
) {
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	const tradeEncodedData = synthethixInterface.encodeFunctionData('trade', [
		MARKET_ADDRESES[marketIdentifier],
		sizeDelta,
		priceImpact
	]);

	const synthetixPerpConnector = await getSynthetixConnector(marketIdentifier);
	return {
		_target: synthetixPerpConnector,
		_callData: tradeEncodedData
	};
}

export function limitTrade(
	marketIdentifier: MarketIdentifiers,
	sizeDelta: string,
	priceImpact: string,
	triggerPrice: string,
	limitPrice: string,
	isUpper: boolean,
	expiry: string
) {
	const synthethixLimitOrderInterface = new Interface(abi.scWalletSynthetixPerpV2LimitOrder);
	const request = {
		isUpper: isUpper,
		triggerPrice: triggerPrice,
		limitPrice: limitPrice,
		sizeDelta: sizeDelta,
		priceImpactDelta: priceImpact,
		expiry: expiry
	};
	const tradeEncodedData = synthethixLimitOrderInterface.encodeFunctionData('submitLimitOrder', [
		MARKET_ADDRESES[marketIdentifier],
		request
	]);
	return {
		_target: SYNTHETIX_PERP_LIMIT_CONNECTOR,
		_callData: tradeEncodedData
	};
}

export const closeFullTrade = async (
	marketIdentifier: MarketIdentifiers,
	priceImpact: string
): Promise<IConnectorReturnData> => {
	const synthetixPerpConnector = await getSynthetixConnector(marketIdentifier);
	const target: string = synthetixPerpConnector;

	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	const tradeEncodedData = synthethixInterface.encodeFunctionData('closeTrade', [
		MARKET_ADDRESES[marketIdentifier],
		priceImpact
	]);
	return {
		_target: target,
		_callData: tradeEncodedData
	};
};

export async function short(
	marketIdentifier: MarketIdentifiers,
	sizeDelta: string,
	priceImpact: string,
	getId = 0,
	setId = 0
) {
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	const tradeEncodedData = synthethixInterface.encodeFunctionData('short', [
		MARKET_ADDRESES[marketIdentifier],
		sizeDelta,
		priceImpact,
		getId,
		setId
	]);

	const synthetixPerpConnector = await getSynthetixConnector(marketIdentifier);
	return {
		_target: synthetixPerpConnector,
		_callData: tradeEncodedData
	};
}
